<div class="email-shipping-label-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'emailShippingLabel'|translate}}</h2>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content style="overflow: hidden;">
        <ng-container [ngTemplateOutlet]="labelForm"></ng-container>
    </mat-dialog-content>
    <upsc-element-blocker [isPageBlocker]="true" *ngIf="isInProgress"></upsc-element-blocker>
</div>
<ng-template #labelForm>
    <form #shipmentLabelForm="ngForm" class="ups-form">
        <div class="form-body">
            <div class="form-section">
                <div class="form-section-header">
                    <div class="form-section-title">{{'emailTo'|translate}}</div>
                </div>

                <mat-form-field>
                    <mat-label>{{'EmailAddress'|translate}}</mat-label>
                    <textarea matInput
                              name="emailTo"
                              type="email"
                              cols="30"
                              rows="1"
                              required
                              [(ngModel)]="emailTo"
                              class="emailTo"
                              (input)="fillToEmails()"></textarea>
                    <mat-hint>{{'enter5Emails'|translate}}</mat-hint>
                </mat-form-field>
            </div>

            <div class="form-section ship-from-contact">
                <div class="form-section-header">
                    <div class="form-section-title">{{'shipFromContact'|translate}}</div>
                </div>

                <div class="ship-from-contact-items">
                    <mat-form-field>
                        <mat-label>{{'EmailAddress'|translate}}</mat-label>
                        <input matInput
                               name="EmailAddress"
                               required
                               onfocus="this.select();"
                               type="text"
                               autocomplete="off" [(ngModel)]="emailShippingLabel.FromEmail">
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>{{'PhoneNumber'|translate}}</mat-label>
                        <input matInput
                               name="PhoneNumber"
                               type="text"
                               required
                               autocomplete="off"
                               [(ngModel)]="emailShippingLabel.PhoneNumber">
                    </mat-form-field>
                </div>
            </div>

            <div class="form-section">
                <div class="form-section-header">
                    <div class="form-section-title shipping-instruction-toggle"
                         (click)="shouldShowShippingInstruction = !shouldShowShippingInstruction">
                         {{'shippingInstruction.title' | translate}}
                    </div>
                </div>

                <div class="shipping-instructions" [class.opened]="shouldShowShippingInstruction">
                    <p>
                        {{'shippingInstruction.instructionInfo' | translate}}
                    </p>

                    <ol>
                        <li>{{ 'shippingInstruction.instruction1' | translate }}
                        </li>
                        <li>{{ 'shippingInstruction.instruction2' | translate }}
                        </li>
                        <li>{{ 'shippingInstruction.instruction3' | translate }}
                        </li>
                        <li>{{ 'shippingInstruction.instruction4' | translate : { phoneNumber: emailShippingLabel?.PhoneNumber, fromEmail: emailShippingLabel?.FromEmail } }}                            
                        </li>
                    </ol>
                </div>
            </div>

            <div class="form-section">
                <div class="form-section-header">
                    <div class="form-section-title">{{'additionalInstructions'|translate}}</div>
                </div>

                <mat-form-field>
                    <textarea matInput
                              cols="30"
                              rows="4"
                              name="AdditionalInstructions"
                              [(ngModel)]="emailShippingLabel.Instructions"></textarea>
                </mat-form-field>
            </div>

            <div class="form-section upload-attachment">
                <upsc-file-selector [label]="'uploadAttachment'|translate"
                                    [buttonClass]="'alternative-button'"
                                    [isDisabled]="uploadedFile"
                                    [clearFileControl]="true"
                                    (fileSelectionChanged)="uploadFiles($event)"></upsc-file-selector>
                <div class="file-name" *ngIf="uploadedFile">{{ uploadedFile }}</div>
                <div class="remove-file">
                    <a href="javascript:;" *ngIf="uploadedFile" (click)="removeFile()">{{'Remove'|translate}}</a>
                </div>
            </div>

            <div class="form-section hide-me">
                <mat-checkbox>{{'readAndAgree'|translate}}</mat-checkbox>
                <p>
                   {{'insuredTerms'|translate}}
                </p>
            </div>
        </div>
        <div class="form-footer">
            <div class="form-actions">
                <button type="button"
                        [disabled]="!isFormValid"
                        mat-raised-button
                        class="form-action"
                        (click)="uploadAttachment()">
                    {{'Send'|translate}}
                </button>
            </div>
        </div>
    </form>
    <!--<div class="row form-group">-->
    <!--<div class="col-md-10 col-sm-10 col-xs-10 orange-font text-bigger">-->
    <!--Email To-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="row form-group">-->
    <!--<div class="col-md-10 col-sm-10 col-xs-10">-->
    <!--<textarea style="width:100%;resize:none;"-->
    <!--rows="4"-->
    <!--placeholder="Enter up to 5 email addresses separated by a comma"-->
    <!--[(ngModel)]="emailTo"-->
    <!--(input)="fillToEmails()"> </textarea>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="row form-group">-->
    <!--<div class="col-md-10 col-sm-10 col-xs-10 orange-font text-bigger">-->
    <!--Ship From Contact-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="row  row-bottom-4">-->
    <!--<div class="col-md-5 col-sm-5 col-xs-10 pull-left-12">-->
    <!--<label class="control-label ctrl-label text-normal text-extra-small" for="emailAddress">Email-->
    <!--Address</label>-->
    <!--<input id="emailAddress" name="Email Address"-->
    <!--placeholder="Email Address"-->
    <!--required-->
    <!--matInput-->
    <!--onfocus="this.select();"-->
    <!--type="text"-->
    <!--autocomplete="off" [(ngModel)]="emailShippingLabel.FromEmail">-->
    <!--</div>-->
    <!--<div class="col-md-5 col-sm-5 col-xs-10">-->
    <!--<label class="control-label ctrl-label text-normal text-extra-small" for="phoneNumber">Phone Number</label>-->
    <!--<input id="phoneNumber"-->
    <!--name="Phone Number"-->
    <!--placeholder="Phone Number"-->
    <!--class="form-control input-md txtbox"-->
    <!--type="text"-->
    <!--required-->
    <!--autocomplete="off"-->
    <!--[(ngModel)]="emailShippingLabel.PhoneNumber">-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="row row-bottom-4">-->
    <!--<div class="col-md-10 col-sm-10 col-xs-10 view-instruction text-bigger">-->
    <!--View Shipping Instruction-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="row form-group">-->
    <!--<div class="col-md-10 col-sm-10 col-xs-10 orange-font text-bigger">-->
    <!--Addition Instructions-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="row form-group">-->
    <!--<div class="col-md-10 col-sm-10 col-xs-10">-->
    <!--<textarea style="width:100%;resize:none;"-->
    <!--rows="4"-->
    <!--placeholder="Option Message"-->
    <!--maxlength="500"-->
    <!--[(ngModel)]="emailShippingLabel.Instructions"> </textarea>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="row form-group">-->
    <!--<div class="col-md-3 col-sm-3 col-xs-6">-->
    <!--<div>-->
    <!--<div class="file-upload" [ngClass]="{'disabled' : uploadedFile}">-->
    <!--<label class="upload-button btn btn-sm btn-sky white-font">-->
    <!--<span>Upload Attachment</span>-->
    <!--<input id="file" type="file" (change)="uploadFile($event)" *ngIf="!uploadedFile" name="files"/>-->
    <!--</label>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="col-md-3 col-sm-3 col-xs-3 file-name">-->
    <!--<span *ngIf="uploadedFile"> {{uploadedFile}}</span>-->
    <!--</div>-->
    <!--<div class="col-md-3 col-sm-3 col-xs-3 mt-5">-->
    <!--<a href="javascript:;" *ngIf="uploadedFile" class="remove" (click)="removeFile()">Remove</a>-->
    <!--</div>-->
    <!--</div>-->
</ng-template>
